import * as React from 'react';
import { Button, UIHeading2, UIText1 } from '@cian/ui-kit';
import * as styles from './NotFoundForFiltersMobile.css';

interface INotFoundForFiltersMobileProps {
  showFilters(): void;
}

export const NotFoundForFiltersMobile: React.VFC<INotFoundForFiltersMobileProps> = ({ showFilters }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['image']} />
      <div>
        <UIHeading2>У нас ещё нет посёлков по такому запросу</UIHeading2>
        <div className={styles['description']}>
          <UIText1>Попробуйте изменить что-нибудь в фильтрах</UIText1>
        </div>
        <div className={styles['button']}>
          <Button fullWidth onClick={showFilters}>
            Изменить фильтры
          </Button>
        </div>
      </div>
    </div>
  );
};
